// auto-generated
export const VERSION = "2.0.0-alpha.33";
